import { makeStyles } from "@material-ui/core/styles";
import {
  ACTION_BTNS_HEIGHT,
  ACTION_BTNS_WIDTH,
  TABS_CONTAINER_WIDTH,
} from "../formContainerV2/FormContainerV2Styles";
import { BORDER_RADIUS_FIELDS } from "../customSimpleFields/styles/SharedStyles";
import {
  appBarHeight,
  drawerWidth,
} from "../../../shared/layout/LayoutStylesGlobals";
import { BREAKPOINT_SM } from "../../../util/Constants";

const BORDER_RADIUS = 5;
export const FOOTER_MIN_HEIGHT = "50px";

export const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
};

export const backButton = {
  padding: 5,
  marginRight: 15,
};

const useStylesHook = makeStyles((theme) => ({
  contentContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.form.background,
    minWidth: 300,
    borderRadius: BORDER_RADIUS,
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  mainContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "100%",
    backgroundColor: theme.palette.form.background,
    borderRadius: BORDER_RADIUS,
    width: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 10px",
    backgroundColor: theme?.palette?.header?.backgroundColor,
    height: 40,
    width: "100%",
    position: "relative",
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      height: 80,
      alignItems: "center",
      justifyContent: "space-around",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      height: 80,
      alignItems: "center",
      justifyContent: "space-around",
    },
  },
  headerStartButtonGroup: {
    marginLeft: 10,
    display: "flex",
    columnGap: "10px",
  },
  headerTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "absolute",
    right: 0,
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
    },
  },
  contentContainerColumn: {
    display: "flex",
    //IF tabs to horizontal uncomment the line below
    flexDirection: "column",
    flex: 1,
    marginLeft: "15px",
    width: "calc(100% - 30px)",
  },
  tabsContainer: {
    marginBottom: 5,
  },
  tabIndicatorProps: {
    background: theme.palette.content.mainColor,
    width: "5px",
    borderTopLeftRadius: 50,
    borderBottomLeftRadius: 50,
  },
  tabRoot: {
    display: "-webkit-inline-box",
    textAlign: "left",
    "&:active": {
      fontWeight: "bold",
    },
  },
  tabIconWrapper: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
  },
  tabLabelContainer: {
    width: "auto",
    padding: 0,
  },
  tabLabelIcon: {
    paddingTop: 9,
    minHeight: "inherit",
  },
  formContainer: {
    width: "100%",
    height: "100%",
    margin: "0px 10px 10px 0px",
    overflowY: "auto",
  },
  gridLayout: {
    boxShadow:
      "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  footer: {
    backgroundColor: theme?.palette?.header?.backgroundColor,
    width: "100%",
    minHeight: FOOTER_MIN_HEIGHT,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    //boxShadow: "0px -1px 8px -3px #CDCDCD",
    borderBottomLeftRadius: BORDER_RADIUS,
    borderBottomRightRadius: BORDER_RADIUS,
  },

  editButtonCommon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    color: theme.palette.content.mainColor,
    cursor: "pointer",
    fontWeight: "700",
    outline: "none",
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.content.mainColor}`,
    marginLeft: 10,
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  editButtonCommonSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    color: "white",
    cursor: "pointer",
    fontWeight: "700",
    border: "none",
    outline: "none",
    backgroundColor: theme.palette.content.mainColor,
    marginLeft: 10,
    transform: "scale(1.1)",
  },
  deleteButtonCommon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    backgroundColor: "transparent",
    color: "rgb(109, 109, 109)",
    cursor: "pointer",
    fontWeight: "700",
    border: "1px solid #f87979",
    margin: "0px 10px",
    outline: "none",
    "&:hover": {
      border: "1px solid red",
      transform: "scale(1.1)",
    },
  },
  deleteButtonCommonSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    backgroundColor: "#f87979",
    color: "rgb(109, 109, 109)",
    cursor: "pointer",
    fontWeight: "700",
    border: "1px solid #f87979",
    margin: "0px 10px",
    outline: "none",
    transform: "scale(1.1)",
  },
  footerEndButtonGroup: {
    marginRight: 10,
    display: "flex",
    columnGap: "10px",
  },
  decisionButtonForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "6vw",
    height: "3vh",
    maxHeight: 28,
    border: "none",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    borderRadius: "5px",
    "&:disabled": {
      color: "grey",
      cursor: "not-allowed",
    },
    "&:hover": {
      transform: "scale(1.1)",
      border: `1px solid`,
    },
  },
}));

const useStylesV2Hook = makeStyles((theme) => ({
  contentContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.form.background,
    minWidth: 300,
    borderRadius: BORDER_RADIUS,
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  fetchingSpinnerContainer: {
    display: "flex",
    flex: "1",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 10px",
    backgroundColor: theme?.palette?.header?.backgroundColor,
    height: 40,
    width: "100%",
    position: "relative",
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      height: "auto",
      alignItems: "center",
      justifyContent: "space-around",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      height: "auto",
      alignItems: "center",
      justifyContent: "space-around",
    },
  },
  headerStartButtonGroup: {
    marginLeft: 10,
    display: "flex",
    columnGap: "10px",
  },
  headerTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "absolute",
    right: 0,
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
    },
  },

  fetchingSpinner: { color: theme.palette.content.mainColor },
  mainContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "100%",
    borderRadius: "20px",
    width: "100%",
  },
  contentContainerColumn: {
    backgroundColor: theme.palette.form.background,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
  },
  contentContainerRow: {
    backgroundColor: theme.palette.form.background,
    display: "flex",
    flexDirection: "row",
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  tabsContainer: {
    minWidth: TABS_CONTAINER_WIDTH,
    maxWidth: ({ openDrawer }) =>
      openDrawer === true
        ? `calc(100vw - ${drawerWidth}px)`
        : `calc(100vw - ${appBarHeight}px)`,
    // backgroundColor: `${
    //   theme.palette.type === "dark" ? BLOCKS_HEADER_BG : "#f9f9f9"
    // }`,
    //padding: 8,
    //borderRight: "1px solid rgb(0 0 0 / 7%)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100% !important",
      padding: "0px",
    },
  },
  tabsRoot: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      minHeight: "auto",
    },
  },
  tabsScrollBtn: {
    color: theme.palette.text.primary,
    width: 30,
    "&.Mui-disabled": {
      color: "grey",
      opacity: "0.6 !important",
    },
  },
  tabsFlexContainer: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      minHeight: "auto",
    },
  },
  tabIndicatorProps: {
    backgroundColor: theme.palette.primary.main,
    width: 8,
    //borderRadius: 10,
    left: 0,
  },
  tabRoot: {
    position: "relative",
    textAlign: "left",
    alignItems: "center",
    justifyContent: "flex-start",
    textTransform: "none",
    padding: "8px 12px 8px 20px",
    minHeight: 60,
    //borderRadius: 8,
    marginBottom: 4,
    fontSize: "1.75rem",
    "&:hover": {
      background: `linear-gradient(90deg,${theme.palette.content.mainColor}33 93%, rgba(145, 49, 49, 0) 0%)`,
    },
    "&.Mui-selected": {
      background: `linear-gradient(90deg,${theme.palette.content.mainColor}55 93%, rgba(145, 49, 49, 0) 0%)`,
      fontWeight: "bold",
      [theme.breakpoints.down("sm")]: {
        background: `${theme.palette.content.mainColor}55`,
      },
    },
    "&.Mui-selected::after": {
      content: '""',
      position: "absolute",
      right: "-10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "25px",
      height: "25px",
      borderTop: "12px solid transparent",
      borderBottom: "12px solid transparent",
      borderLeft: `12px solid ${theme.palette.content.mainColor}55`,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    "&.Mui-selected::before": {
      display: "none",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "25%",
      height: "2px",
      background: `${theme.palette.content.mainColor}66`,
      opacity: 0.5,
      pointerEvents: "none",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
      marginBottom: 0,
      minHeight: "auto",
    },
  },

  tabIconWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
    justifyContent: "flex-start",
  },

  tabLabelContainer: {
    width: "auto",
    padding: 0,
  },
  tabLabelIcon: {
    paddingTop: 9,
    minHeight: 60,
    [theme.breakpoints.down("xs")]: {
      minHeight: 40,
      padding: "0px 12px",
    },
  },
  tabLabelTitle: {
    fontSize: 16,
    fontWeight: "bold",
  },
  tabLabelDescription: {
    fontSize: 11,
    fontWeight: "100",
    maxWidth: TABS_CONTAINER_WIDTH - 50,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  tabSelectedArrowRight: {
    width: "25px",
    height: "25px",
    position: "absolute",
    borderTop: "12px solid transparent",
    borderBottom: "12px solid transparent",
    borderLeft: `15px solid ${theme.palette.content.mainColor}55`,
    right: "-10px",
  },
  formContainer: {
    width: "100%",
    height: "100%",
    margin: "0px 10px 10px 0px",
  },
  gridLayout: {
    boxShadow:
      "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  formHeader: {
    width: "100%",
    padding: 6,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.content.mainColor}55`,
    position: "relative",
    minHeight: 30,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  footer: {
    width: "100%",
    padding: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 45,
    [theme.breakpoints.down("xs")]: {
      padding: 20,
    },
  },
  footerStartButtonGroup: {
    marginLeft: 10,
    display: "flex",
    columnGap: "10px",
  },
  editButtonCommon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    color: theme.palette.content.mainColor,
    cursor: "pointer",
    fontWeight: "700",
    outline: "none",
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.content.mainColor}`,
    marginLeft: 10,
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  editButtonCommonSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    color: "white",
    cursor: "pointer",
    fontWeight: "700",
    border: "none",
    outline: "none",
    backgroundColor: theme.palette.content.mainColor,
    marginLeft: 10,
    transform: "scale(1.1)",
  },
  deleteButtonCommon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    backgroundColor: "transparent",
    color: "rgb(109, 109, 109)",
    cursor: "pointer",
    fontWeight: "700",
    border: "1px solid #f87979",
    margin: "0px 10px",
    outline: "none",
    "&:hover": {
      border: "1px solid red",
      transform: "scale(1.1)",
    },
  },
  deleteButtonCommonSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    backgroundColor: "#f87979",
    color: "rgb(109, 109, 109)",
    cursor: "pointer",
    fontWeight: "700",
    border: "1px solid #f87979",
    margin: "0px 10px",
    outline: "none",
    transform: "scale(1.1)",
  },
  footerEndButtonGroup: {
    marginRight: 10,
    display: "flex",
    columnGap: "10px",
  },
  decisionButtonForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: ACTION_BTNS_WIDTH,
    height: ACTION_BTNS_HEIGHT,
    maxHeight: ACTION_BTNS_HEIGHT,
    border: "none",
    cursor: "pointer",
    backgroundColor: theme.palette.semaphore.green,
    color: "#FFF",
    borderRadius: BORDER_RADIUS_FIELDS,
    "&:disabled": {
      color: "grey",
      cursor: "not-allowed",
    },
    "&:hover": {
      transform: "scale(1.05)",
      //borderBottom: `2px solid ${theme.palette.content.mainColor}`,
    },
  },
  decisionCancelButtonForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: ACTION_BTNS_WIDTH,
    height: ACTION_BTNS_HEIGHT,
    maxHeight: ACTION_BTNS_HEIGHT,
    border: "none",
    cursor: "pointer",
    backgroundColor: theme.palette.semaphore.red,
    color: "#FFF",
    borderRadius: BORDER_RADIUS_FIELDS,
    "&:disabled": {
      color: "grey",
      cursor: "not-allowed",
    },
    "&:hover": {
      transform: "scale(1.05)",
      //borderBottom: `2px solid ${theme.palette.content.mainColor}`,
    },
  },
  decisionButtonBackForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: ACTION_BTNS_WIDTH,
    height: ACTION_BTNS_HEIGHT,
    maxHeight: ACTION_BTNS_HEIGHT,
    border: "1px solid grey",
    cursor: "pointer",
    backgroundColor: "transparent",
    borderRadius: BORDER_RADIUS_FIELDS,
    "&:disabled": {
      cursor: "not-allowed",
    },
    "&:hover": {
      transform: "scale(1.05)",
      //borderBottom: `2px solid ${theme.palette.content.mainColor}`,
    },
  },
  responsiveGridLayout: {
    boxShadow:
      "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    borderRadius: "10px",
  },
  formNameDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: ({ wd }) =>
      wd && wd.width > BREAKPOINT_SM ? "absolute" : "relative",
    right: 0,
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    [theme.breakpoints.down("xs")]: {
      marginBottom: 3,
    },
  },
  iconButtonOpenTrazability: {
    padding: 0,
  },
  pinButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    width: "2.5em",
    height: "3vh",
    maxHeight: 28,
    backgroundColor: "transparent",
    color: theme.palette.content.mainColorContrastText,
    cursor: "pointer",
    fontWeight: "700",
    border: `1px solid ${theme.palette.content.mainColorContrastText}`,
    margin: "0px 10px",
    outline: "none",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  pinButtonAdded: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    height: "2.5em",
    width: "4vh",
    backgroundColor: "transparent",
    color: theme.palette.content.mainColor,
    cursor: "pointer",
    fontWeight: "700",
    border: `1px solid ${theme.palette.content.mainColor}`,
    margin: "0px 10px",
    outline: "none",
    transform: "rotate(90deg)",
  },
  actionTypo: {
    fontSize: "1.05rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.15rem",
    },
  },
}));

// Create a custom hook that returns the appropriate styles
export const useStyles = (props) => {
  const stylesV1 = useStylesHook(props);
  const stylesV2 = useStylesV2Hook(props);

  // Return the appropriate styles based on version
  return props.isV2Styles === true ? stylesV2 : stylesV1;
};
